<template>
  <section class="rl z">
    <div class="d-block d-md-flex">
      <div
        @click="$emit('showphotos', { index: 0 })"
        class="image-holder lg rl fade-in-item right"
        :style="'background-image: url(' + images[0] + ');'"
      ></div>
      <div class="s full">
        <div class="d-flex">
          <div
            class="image-holder fade-in-item left"
            @click="$emit('showphotos', { index: 1 })"
          >
            <img :src="images[1]" />
          </div>
          <div
            class="image-holder fade-in-item left"
            @click="$emit('showphotos', { index: 4 })"
          >
            <img :src="images[4]" />
          </div>
        </div>
        <div class="d-flex">
          <div
            class="image-holder fade-in-item left"
            @click="$emit('showphotos', { index: 5 })"
          >
            <img :src="images[5]" />
          </div>
          <div
            class="image-holder fade-in-item left"
            @click="$emit('showphotos', { index: 6 })"
          >
            <img :src="images[6]" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["images"],
};
</script>
